<template>
  <div class="exchangeOffersDashboard js-tabBox exchangeOffersDashboard--admin">
    <div class="exchangeOffersDashboard__header">
      <div class="exchangeOffersDashboard__title">Exchange Offers</div>
      <div class="exchangeOffersDashboard__nav">
        <div class="exchangeOffersDashboard__nav-container">
          <div data-id="charter-re-sale" class="exchangeOffersDashboard__nav-item js-tabNavItem" @click="tabActivate">
            <span class="text">Charter Res-sale</span>
          </div>
          <div data-id="spaces" class="exchangeOffersDashboard__nav-item js-tabNavItem" @click="tabActivate">
            <span class="text">Spaces</span>
          </div>
          <div data-id="jet-card-hours" class="exchangeOffersDashboard__nav-item js-tabNavItem" @click="tabActivate">
            <span class="text">Jet Card Hours</span>
          </div>
        </div>
        <div class="exchangeOffersDashboard__nav-container">
          <div
            class="exchangeOffersDashboard__nav-item"
            :class="{'active': historical === false}"
            @click="switchMode(false)">
            <span class="text">Current</span>
          </div>
          <div
            class="exchangeOffersDashboard__nav-item"
            :class="{'active': historical === true}"
            @click="switchMode(true)">
            <span class="text">Historical</span>
          </div>
          <div class="exchangeOffersDashboard__nav-item" @click="exportToExcel()">
            <span class="text">Export</span>
          </div>
        </div>
      </div>
    </div>
    <div class="exchangeOffersDashboard__content">
      <div class="exchangeOffersDashboard__content-item js-tabContentItem">
        <div class="exchangeOffersDashboard__table">
          <div class="exchangeOffersDashboard__table-header">
            <div class="exchangeOffersDashboard__table-cell">№</div>
            <div class="exchangeOffersDashboard__table-cell">Offerer</div>
            <div class="exchangeOffersDashboard__table-cell">Type</div>
            <div class="exchangeOffersDashboard__table-cell">Model</div>
            <div class="exchangeOffersDashboard__table-cell">Departure</div>
            <div class="exchangeOffersDashboard__table-cell">Arrival</div>
            <div class="exchangeOffersDashboard__table-cell">Date</div>
            <div class="exchangeOffersDashboard__table-cell">Price</div>
            <div class="exchangeOffersDashboard__table-cell">Sold</div>
          </div>
          <div class="exchangeOffersDashboard__table-body js-customScroll">
            <vue-scroll :ops="ops">
              <div
                v-for="(item, index) of charterResaleOffersList"
                :key="index"
                class="exchangeOffersDashboard__table-row js-acc-item js-acc-hover-item"
                @mouseenter="controlShow"
                @mouseleave="controlHide"
                @click="getBidsByOfferId(item.id)"
              >
                <div class="exchangeOffersDashboard__table-row-header js-acc-title">
                  <div class="exchangeOffersDashboard__table-cell">
                    <div class="exchangeOffersDashboard__table-index">{{charterResaleOffersList.length - index}}</div>
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">
                    <a
                    @click="(e) => openAdditionalDetails(e, item.offerCreator)"
                    class="exchangeOffersDashboard__table-name">{{item.offerCreator.firstName + ' ' + item.offerCreator.lastName}}</a>
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">{{item.aircraftType.name}}</div>
                  <div class="exchangeOffersDashboard__table-cell">
                    {{item.aircraftModel.name}}
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">
                    {{item.departure.airport_Id}}
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">
                    {{item.arrival.airport_Id}}
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">
                    <span>{{getDisplayDate(item.date)}}</span>
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">
                    {{item.price.amount}}
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">
                    {{item.sold ? 'sold' : ''}}
                  </div>
                </div>
                <div class="exchangeOffersDashboard__table-row-control js-acc-hover-content">
                  <div class="exchangeOffersDashboard__table-row-control-inner ">
                    <p class="exchangeOffersDashboard__table-link" @click="(e) => deleteOfferClick(e, item)">
                      <span class="icon" />
                      <span class="text">Delete</span>
                    </p>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
      <div class="exchangeOffersDashboard__content-item js-tabContentItem">
        <div class="exchangeOffersDashboard__table">
          <div class="exchangeOffersDashboard__table-header">
            <div class="exchangeOffersDashboard__table-cell">№</div>
            <div class="exchangeOffersDashboard__table-cell">Offerer</div>
            <div class="exchangeOffersDashboard__table-cell">Type</div>
            <div class="exchangeOffersDashboard__table-cell">Model</div>
            <div class="exchangeOffersDashboard__table-cell">Departure</div>
            <div class="exchangeOffersDashboard__table-cell">Arrival</div>
            <div class="exchangeOffersDashboard__table-cell">Date</div>
            <div class="exchangeOffersDashboard__table-cell">Spaces</div>
            <div class="exchangeOffersDashboard__table-cell">Price</div>
            <div class="exchangeOffersDashboard__table-cell">Spaces sold</div>
          </div>
          <div class="exchangeOffersDashboard__table-body js-customScroll">
            <vue-scroll :ops="ops">
              <div
                v-for="(item, index) of spacesOffersList"
                :key="index"
                class="exchangeOffersDashboard__table-row js-acc-item js-acc-hover-item"
                @mouseenter="controlShow"
                @mouseleave="controlHide"
                @click="getBidsByOfferId(item.id)"
              >
                <div class="exchangeOffersDashboard__table-row-header js-acc-title">
                  <div class="exchangeOffersDashboard__table-cell">
                    <div class="exchangeOffersDashboard__table-index">{{spacesOffersList.length - index}}</div>
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">
                    <a
                   @click="(e) => openAdditionalDetails(e, item.offerCreator)"
                    class="exchangeOffersDashboard__table-name">{{item.offerCreator.firstName + ' ' + item.offerCreator.lastName}}</a>
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">{{item.aircraftType.name}}</div>
                  <div class="exchangeOffersDashboard__table-cell">
                    {{item.aircraftModel.name}}
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">
                    {{item.departure.airport_Id}}
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">
                    {{item.arrival.airport_Id}}
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">
                    <span>{{getDisplayDate(item.date)}}</span>
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">
                    {{item.numberOfSpaces}}
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">
                    {{item.price.amount}}
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">
                    {{item.spacesSold}}
                  </div>
                </div>
                <div class="exchangeOffersDashboard__table-row-control js-acc-hover-content">
                  <div class="exchangeOffersDashboard__table-row-control-inner ">
                    <p class="exchangeOffersDashboard__table-link" @click="(e) => deleteOfferClick(e, item)">
                      <span class="icon" />
                      <span class="text">Delete</span>
                    </p>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
      <div class="exchangeOffersDashboard__content-item js-tabContentItem">
        <div class="exchangeOffersDashboard__table">
          <div class="exchangeOffersDashboard__table-header">
            <div class="exchangeOffersDashboard__table-cell">№</div>
            <div class="exchangeOffersDashboard__table-cell">Offerer</div>
            <div class="exchangeOffersDashboard__table-cell">Type</div>
            <div class="exchangeOffersDashboard__table-cell">Model</div>
            <div class="exchangeOffersDashboard__table-cell">Expires on</div>
            <div class="exchangeOffersDashboard__table-cell">Hours</div>
            <div class="exchangeOffersDashboard__table-cell">Price</div>
            <div class="exchangeOffersDashboard__table-cell">Sold</div>
          </div>
          <div class="exchangeOffersDashboard__table-body js-customScroll">
            <vue-scroll :ops="ops">
              <div
                v-for="(item, index) of jetCardHoursOffersList"
                :key="index"
                class="exchangeOffersDashboard__table-row js-acc-item js-acc-hover-item"
                @mouseenter="controlShow"
                @mouseleave="controlHide"
                @click="getBidsByOfferId(item.id)"
              >
                <div class="exchangeOffersDashboard__table-row-header js-acc-title">
                  <div class="exchangeOffersDashboard__table-cell">
                    <div class="exchangeOffersDashboard__table-index">{{jetCardHoursOffersList.length - index}}</div>
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">
                    <a
                   @click="(e) => openAdditionalDetails(e, item.offerCreator)"
                    class="exchangeOffersDashboard__table-name">{{item.offerCreator.firstName + ' ' + item.offerCreator.lastName}}</a>
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">{{item.aircraftType.name}}</div>
                  <div class="exchangeOffersDashboard__table-cell">
                    {{item.aircraftModel.name}}
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">
                    <span>{{getDisplayDate(item.expiresOn)}}</span>
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">
                    {{item.numberOfHours}}
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">
                    {{item.price.amount}}
                  </div>
                  <div class="exchangeOffersDashboard__table-cell">
                    {{item.sold ? 'sold' : ''}}
                  </div>
                </div>
                <div class="exchangeOffersDashboard__table-row-control js-acc-hover-content">
                  <div class="exchangeOffersDashboard__table-row-control-inner ">
                    <p class="exchangeOffersDashboard__table-link" @click="(e) => deleteOfferClick(e, item)">
                      <span class="icon" />
                      <span class="text">Delete</span>
                    </p>
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </div>
    </div>
    <FlyerDetailsPopup />
    <QuestionPopup
      :name="'QuestionPopupDelete'"
      :title="'The offer will be deleted'"
      :text="'Are you sure?'"
      @remove="deleteOffer"
    />
    <InfoPopup/>
    <Teleport to="body">
      <OfferBidsPopup/>
    </Teleport>
  </div>
</template>

<script>
  import { reportsAPI } from '@/api/reports'
  import { Tabs } from '@/js/plugins/tabs'
  import Teleport from 'vue2-teleport';
  import FlyerDetailsPopup from '@/components/common/modals/FlyerDetailsPopup'
  import OfferBidsPopup from '@/components/common/modals/OfferBidsPopup.vue';
  import QuestionPopup from '@/components/common/modals/QuestionPopup'
  import InfoPopup from '@/components/common/modals/InfoPopup.vue';
  import './ExchangeOffers.styl'
  import moment from 'moment'

  export default {
    name: 'exchangeMembershipApps',
    data: () => ({
      tabs: new Tabs('.js-tabNavItem', '.js-tabContentItem'),
      ops: {
        rail: {
          size: '3px',
        },
        bar: {
          size: '3px',
          background: 'rgba(0,0,0,0.1)',
        },
      },
      tabSelected: 'charterResaleOffers',
      currentItem: null,
      historical: false,
    }),
    computed: {
      charterResaleOffersList () {
        return this.$store.state.exchangeOffers.charterResaleOffersList
      },
      spacesOffersList () {
        return this.$store.state.exchangeOffers.spacesOffersList
      },
      jetCardHoursOffersList () {
        return this.$store.state.exchangeOffers.jetCardHoursOffersList
      },
    },
    async mounted () {
      this.tabs.addActiveForMouted()
      await this.$store.dispatch('getOffersList', false);
    },
    methods: {
      controlShow (event) {
        const item = event.currentTarget.closest('.exchangeOffersDashboard__table-row').querySelector('.js-acc-hover-content')
        this.$root.animations.slideDown(item)
        item.classList.add('show')
      },
      controlHide (event) {
        const item = event.currentTarget.closest('.exchangeOffersDashboard__table-row').querySelector('.js-acc-hover-content')
        item.classList.remove('show')
        this.$root.animations.slideUp(item)
      },
      openAdditionalDetails (e, account) {
        e.stopPropagation()
        this.$modal.show('FlyerDetailsPopup', {additionalInfo: account})
      },
      moment,
      tabActivate (event) {
        if (event.currentTarget.getAttribute('data-id') === 'charter-re-sale') {
          this.tabSelected = 'charterResaleOffers'
        } else if (event.currentTarget.getAttribute('data-id') === 'spaces') {
          this.tabSelected = 'spacesOffers'
        } else {
          this.tabSelected = 'jetCardHoursOffers'
        }
        this.tabs.addActiveForClick(event.currentTarget)
      },
      async exportToExcel () {
        try {
          const mode = this.historical ? 'historical' : 'current'
          const { data } = await reportsAPI.exchangeOffers(this.tabSelected, mode)
          const downloadLink = document.createElement('a');
          const blob = new Blob(['\ufeff', data]);
          const url = window.URL.createObjectURL(blob);
          downloadLink.href = url;
          downloadLink.download = 'exchangeOffers_report_' + new Date().toLocaleDateString().replaceAll('/', '-') + '.csv';
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
        } catch (e) {
          console.log(e)
        }
      },
      getDisplayDate (dateString) {
      return dateString === null
        ? ''
        : `${new Date(dateString).toLocaleDateString('en-US')}`;
      },
      deleteOfferClick (e, item) {
        e.stopPropagation();
        this.currentItem = item;
        this.$modal.show('QuestionPopupDelete');
      },
      async deleteOffer () {
        const res = await this.$store.dispatch('deleteOffer', this.currentItem.id);
        console.log(res)
          if (!res.isSuccessfull) {
            this.$modal.show('InfoPopup', {
              title: 'Error',
              text: res.message,
            });
          } else {
            this.$router.go();
          }
          this.currentItem = null;
          this.$modal.hide('QuestionPopupDelete')
      },
      async switchMode (historical) {
        this.historical = historical;
        await this.$store.dispatch('getOffersList', historical);
      },
      async getBidsByOfferId (offerId) {
        await this.$store.dispatch('getBidsByOfferId', offerId);
        this.$modal.show('offerBids')
      },
    },
    components: {
      FlyerDetailsPopup,
      OfferBidsPopup,
      QuestionPopup,
      InfoPopup,
      Teleport,
    },
  }
</script>